var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticStyle:{"padding":"100px 0"}},[_c('BaseMaxWidthContainer',[_c('FeatureList',{attrs:{"items":_vm.items}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }